var map = {
	"./chirpie/audio/0.mp3": 22297,
	"./chirpie/audio/1.mp3": 74632,
	"./dali/audio/0.mp3": 19363,
	"./dali/audio/1.mp3": 34842,
	"./donut/audio/0.mp3": 64290,
	"./donut/audio/1.mp3": 88482,
	"./donut/audio/2.mp3": 21365,
	"./echo_delay/audio/0.mp3": 47221,
	"./fann/audio/0.mp3": 35932,
	"./fluffy/audio/0.mp3": 61057,
	"./fluffy/audio/1.mp3": 26106,
	"./fuyu/audio/0.mp3": 59706,
	"./karl/audio/0.mp3": 46855,
	"./lulu/audio/0.mp3": 17616,
	"./lulu/audio/1.mp3": 73278,
	"./lulu/audio/2.mp3": 30151,
	"./maggie/audio/0.mp3": 56338,
	"./maggie/audio/1.mp3": 84292,
	"./marsh/audio/0.mp3": 77682,
	"./marsh/audio/1.mp3": 14676,
	"./marsh/audio/2.mp3": 86902,
	"./pisces/audio/0.mp3": 71366,
	"./pisces/audio/1.mp3": 12684,
	"./rappit/audio/0.mp3": 56597,
	"./rappit/audio/1.mp3": 66863,
	"./sandy/audio/0.mp3": 25662,
	"./shojo/audio/0.mp3": 4158,
	"./shojo/audio/1.mp3": 92144,
	"./spike/audio/0.mp3": 1410,
	"./spike/audio/1.mp3": 43455,
	"./spike/audio/2.mp3": 65572,
	"./wako/audio/0.mp3": 7908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12618;